import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MessagePropType from '../definitions/MessagePropType';
import Colours from '../definitions/Colours';
import Sizes from '../definitions/Sizes';
import Paragraph from './Paragraph';


function CalculationPanel({ title, children, ...otherProps }) {
    return (
        <CalculationPanel.Container {...otherProps}>
            <If condition={title}>
                <div className="titleContainer">
                    <Paragraph
                        className="title"
                        message={title}
                        weight="medium"
                    />
                </div>
            </If>

            {children}
        </CalculationPanel.Container>
    );
}

CalculationPanel.propTypes = {
    title: MessagePropType,
    children: PropTypes.node.isRequired,
};

CalculationPanel.defaultProps = {
    title: undefined,
};

// Also imported by CalculationLine in order to round bottom corners of last row
// in panel, which also needs rounding to the same value.
CalculationPanel.PANEL_BORDER_RADIUS = '6px';

CalculationPanel.Container = styled.section`
    display: flex;
    flex-direction: column;

    border: 1px solid ${Colours.BLUEBERRY_DARK};
    border-radius: ${CalculationPanel.PANEL_BORDER_RADIUS};

    > .titleContainer {
        padding: 0 ${Sizes.SPACING.ONE};

        border-bottom: 1px solid ${Colours.BLUEBERRY_DARK};

        text-align: center;

        > .title {
            color: ${Colours.BLUEBERRY_DARK};
        }
    }
`;

export default CalculationPanel;
